import {Component, DestroyRef, inject, OnDestroy, OnInit, signal} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {debounceTime, distinctUntilChanged, Subject} from 'rxjs';
import {FaultyEcuBuildsService} from "../../service/FaultyEcuBuilds.service";

import {fadeInAnimation} from "../../animations/fadeInAnimation";

@Component({
    selector: 'app-faulty-ecu-builds',
    animations: [fadeInAnimation],
    host: {'[@fadeInAnimation]': ''},
    templateUrl: './faulty-ecu-builds.component.html',
    styleUrl: './faulty-ecu-builds.component.css'
})
export class FaultyEcuBuildsComponent implements OnInit, OnDestroy {

    public faultyEcuBuildsService = inject(FaultyEcuBuildsService);
    public faultyEcuBuild = signal<string | null>(null);
    private searchChanges = new Subject<string>();
    private destroyRef = inject(DestroyRef);

    constructor() {
    }

    ngOnInit() {
        this.faultyEcuBuildsService.reset();
        this.searchChanges.pipe(debounceTime(250), distinctUntilChanged(), takeUntilDestroyed(this.destroyRef))
            .subscribe(value => this.faultyEcuBuildsService.search(value));
    }

    getFaultyEcuBuild(value: string) {
        this.faultyEcuBuild.set(value);
    }

    onSearchInput(value: string) {
        this.searchChanges.next(value.trim());
    }

    ngOnDestroy(): void { this.faultyEcuBuildsService.cancel(); }

}
